import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const columnsXS = [
    {
        dataField: 'id',
        text: 'Detalle',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Precio Unitario (S/):' value={row.total_price != null ? formatHelper.toMoney(row.total_price) : formatHelper.toMoney(cell)} />
                    <TableRowField label='Descuento Unitario (S/):' value={formatHelper.toBlankDiscountDetail(row.unit_discount, row.type_unit_discount)} />
                    <TableRowField label='Precio Total (S/):' value={row.total_price != null ? formatHelper.totalPriceDiscounted(row.total_price * row.quantity, row.unit_discount, row.type_unit_discount) : formatHelper.totalPriceDiscounted(row.price * row.quantity, row.unit_discount, row.type_unit_discount)} />
                </div>
            )
        }
    }
]
export const columnsSM = [
    {
        dataField: 'name',
        text: 'Nombre',
        formatter: (cell) => {
            return (
                <span>{cell}</span>
            )
        }
    },
    {
        dataField: 'quantity',
        text: 'Cantidad',
        formatter: (cell) => {
            return (
                <span>{cell}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Precio Unitario (S/)',
        formatter: (cell, row) => {
            return (
                <span>{row.total_price != null ? formatHelper.toMoney(row.total_price) : formatHelper.toMoney(cell)}</span>
            )
        }
    },
    {
        dataField: 'unit_discount',
        text: 'Descuento Unitario (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toBlankDiscountDetail(cell, row.type_unit_discount)}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Precio Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{row.total_price != null ? formatHelper.totalPriceDiscounted(row.total_price * row.quantity, row.unit_discount, row.type_unit_discount) : formatHelper.totalPriceDiscounted(row.price * row.quantity, row.unit_discount, row.type_unit_discount)}</span>
            )
        }
    },
];

export const columns = [
    {
        dataField: 'name',
        text: 'Nombre',
        formatter: (cell) => {
            return (
                <span>{cell}</span>
            )
        }
    },
    {
        dataField: 'quantity',
        text: 'Cantidad',
        formatter: (cell) => {
            return (
                <span>{cell}</span>
            )
        }
    },
    {
        dataField: 'price',
        text: 'Precio Unitario (S/)',
        formatter: (cell, row) => {
            return (
                <span>{row.total_price != null ? formatHelper.toMoney(row.total_price) : formatHelper.toMoney(cell)}</span>
            )
        }
    },
    {
        dataField: 'unit_discount',
        text: 'Descuento Unitario (S/)',
        formatter: (cell, row) => {
            return (
                <span>{formatHelper.toBlankDiscountDetail(cell, row.type_unit_discount)}</span>
            )
        }
    },
    {
        dataField: 'totalPrice',
        text: 'Precio Total (S/)',
        formatter: (cell, row) => {
            return (
                <span>{row.total_price != null ? formatHelper.totalPriceDiscounted(row.total_price * row.quantity, row.unit_discount, row.type_unit_discount) : formatHelper.totalPriceDiscounted(row.price * row.quantity, row.unit_discount, row.type_unit_discount)}</span>
            )
        }
    },
];



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationDetail/_columns.js